export default __webpack_public_path__ + "static/media/soc2.56e5975c.png";